// extracted by mini-css-extract-plugin
export default {"inputPin":"InputPin_inputPin__gaI1s"};